module.exports = "https://www.gc-pro.gnp.com.mx/e31bd6a96379a77c874f1fa57fccacbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-add.svg
// module id = 378
// module chunks = 0